import { AppUserValue, expandAppUserView } from 'lib/actions/apps/app-users'
import { AppUserRef, GetUserSearchTermsResponse } from 'pbts/c1/api/app/v1/app_user'
import { AppUserResponsiblePartyServiceClient, AppUserServiceClient } from 'pbts/c1/api/app/v1/app_user.client'
import { FacetValue } from 'pbts/c1/api/search/v1/facet'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

const transformAppUserView = (au): AppUserValue => expandAppUserView(au.appUserView, au.expanded)

const transformAppUserValue = (resp): Array<AppUserValue> => resp.list.map((v): AppUserValue => expandAppUserView(v, resp.expanded))

const transformAppUserWithAlertValue = (resp): Array<AppUserValue> => resp.list.map((v): AppUserValue => {
    const auv = expandAppUserView(v, resp.expanded)
    auv.alertCount = v.alertCount
    return auv
})

const transformFacetResponse = (d: GetUserSearchTermsResponse): Array<FacetValue> => {
    const item = d?.facets?.facets?.[0]?.item
    return item?.oneofKind === 'value' ? item.value?.values : []
}

export const SetAppUserAccountTypeApi = createMutationApi(
    AppUserServiceClient,
    'update',
    transformAppUserView,
    AppUserRef.typeName,
)
export const SetAppUserIdentityApi = createMutationApi(
    AppUserResponsiblePartyServiceClient,
    'setIdentity',
    transformAppUserView,
    AppUserRef.typeName,
    (cached, newValue) => {
        return { ...cached, ...newValue }
    },
)
export const ResetAppUserIdentityApi = createMutationApi(
    AppUserResponsiblePartyServiceClient,
    'resetIdentity',
    transformAppUserView,
    AppUserRef.typeName,
)

export const countAppUsersWithoutResponsibleParty = createUnaryApi(AppUserServiceClient, 'countAppUsersWithoutResponsibleParty')

export const countHighRiskUsersAndGrants = createUnaryApi(AppUserServiceClient, 'countHighRiskUsersAndGrants')

export const highRiskUsersAndGrants = createUnaryApi(
    AppUserServiceClient,
    'highRiskUsersAndGrants',
    (resp): { list: Array<AppUserValue>, counts: number[], nextPageToken: string } => {
        const list = resp.list.map((v): AppUserValue => {
            return expandAppUserView(v, resp.expanded)
        })
        const counts = resp.counts
        const nextPageToken = resp.nextPageToken
        return { list, counts, nextPageToken }
    },
)

export const searchHighRiskUsersAndGrants = createPagedListApi(
    AppUserServiceClient,
    'highRiskUsersAndGrants',
    (resp): Array<AppUserValue> => resp.list.map((v): AppUserValue => {
        return expandAppUserView(v, resp.expanded)
    }),
)

export const searchAppUsersApi = createPagedListApi(
    AppUserServiceClient,
    'search',
    transformAppUserValue,
    AppUserRef.typeName,
)

export const searchAppUsersWithAlertCountApi = createPagedListApi(
    AppUserServiceClient,
    'searchWithAlerts',
    transformAppUserWithAlertValue,
    AppUserRef.typeName,
)

export const searchApproxCountAppUsersApi = createUnaryApi(
    AppUserServiceClient,
    'searchCount',
)

export const getAppUserCountsByType = createUnaryApi(
    AppUserServiceClient,
    'searchCountsByType',
)

export const getAppUserSearchTerms = createUnaryApi(
    AppUserServiceClient,
    'getUserSearchTerms',
    transformFacetResponse,
)

export const getAppUsersWithoutResponsibleParty = createPagedListApi(
    AppUserServiceClient,
    'appUsersWithoutResponsibleParty',
    transformAppUserValue,
)

export const getAppUserApi = createUnaryApi(AppUserServiceClient, 'get', transformAppUserView, AppUserRef.typeName)
